export const currentFolderScopeLabel = "$RHJtb";
export const recursiveFolderScopeLabel = "s1_i0d";
export default {currentFolderScopeLabel,recursiveFolderScopeLabel};